import React, { useCallback } from 'react';
import {
	Button,
	deleteSummaryItem,
	Modal, Space, Title,
} from '@components';

import { SummaryBlock } from '@api';

interface DeleteSummaryItemModalProps {
	onSubmit: (updatedSummaryBlocks: SummaryBlock[]) => void,
	summaryItemIndex: number,
	summaryBlockIndex: number,
	summaryAgendaItemId: string,
	summaryBlocks: SummaryBlock[],
	closeModal: () => void,
}

function DeleteSummaryItemModal(props: DeleteSummaryItemModalProps): JSX.Element {
	const {
		summaryItemIndex,
		summaryBlockIndex,
		summaryBlocks,
		summaryAgendaItemId,
		closeModal,
		onSubmit,
	} = props;

	const handleSubmit = useCallback((): void => {		
		const updatedSummaryBlocks = deleteSummaryItem(summaryItemIndex, summaryBlockIndex, summaryAgendaItemId, summaryBlocks);
		onSubmit(updatedSummaryBlocks);
		closeModal();
	}, [onSubmit, summaryItemIndex, summaryBlocks, summaryBlockIndex, summaryAgendaItemId, closeModal]);

	return (
		<Modal isOpen>
			<Space alignment="vertical">
				<Title centered>
					Удалить выбранный блок?
				</Title>
				<Space alignment="vertical" gap="20px">
					{/* LATER: text component */}
					<div>
						После удаления восстановить блок невозможно
					</div>
					<Space centered>
						<Button theme="primary" onClick={handleSubmit}>
							Удалить
						</Button>
						<Button onClick={closeModal}>
							Отменить
						</Button>
					</Space>
				</Space>
			</Space>
		</Modal>
	);
}

export {DeleteSummaryItemModal, deleteSummaryItem as DeleteSummaryItem};